import { render, staticRenderFns } from "./SailWind.vue?vue&type=template&id=17fc5ca2&scoped=true&lang=html&"
import script from "./SailWind.vue?vue&type=script&lang=js&"
export * from "./SailWind.vue?vue&type=script&lang=js&"
import style0 from "./SailWind.vue?vue&type=style&index=0&id=17fc5ca2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc5ca2",
  null
  
)

export default component.exports